export { fetchTypeahead } from 'next-flight-server-reference-proxy-loader?id=7fc3e2c25a409edbf9639c36fa088fd05fdec81573&name=fetchTypeahead!'